import { render, staticRenderFns } from "./AnnotationTag.vue?vue&type=template&id=0910827c"
import script from "./AnnotationTag.vue?vue&type=script&lang=js"
export * from "./AnnotationTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports